import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { NewsletterDialog } from "./NewsletterDialog";

interface HeroSectionProps {
  onExploreClick: () => void;
}

export const HeroSection = ({ onExploreClick }: HeroSectionProps) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black px-4 pt-16 pb-8">
      <div className="container mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6 md:space-y-8 text-center lg:text-left order-2 lg:order-1"
          >
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white">
              Aussie{" "}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#9b87f5] to-[#D946EF]">
                LGBTQIA+
              </span>
              {" "}events
            </h1>
            <p className="text-lg md:text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
              We're proudly LGBTQIA+ and Australian owned, and by supporting us, you also support event producers, talent, performers, content creators and the entire community.
            </p>
            <div className="flex flex-wrap justify-center lg:justify-start gap-4">
              <Button 
                onClick={onExploreClick}
                className="relative bg-[#8B5CF6] hover:bg-[#7c4ef3] text-white px-8 py-6 rounded-full text-lg font-medium transition-all duration-300 ease-out hover:scale-105 border-2 border-transparent before:absolute before:inset-0 before:rounded-full before:border-2 before:border-transparent before:bg-gradient-to-r before:from-[#FF0018] before:via-[#FFA52C] before:to-[#00B5E2] before:animate-border-rainbow before:-z-10"
              >
                Explore Events
              </Button>
              <NewsletterDialog />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative block order-1 lg:order-2"
          >
            <div className="relative aspect-square rounded-3xl overflow-hidden">
              <img 
                src="https://cwmaychzwkmeoulfjnhr.supabase.co/storage/v1/object/public/Media%20Assets/Slay%20LGBTQIA%20Ticketing%20Website%20Australia%20Events.jpeg"
                alt="Pride celebration"
                className="object-cover w-full h-full"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};